import {LineStateStatusType} from "../../enums/index";
function GetLineStateText(type) {
  let result = "";
  switch (type) {
    case LineStateStatusType.None():
      result = "هیچکدام";
      break;
    case LineStateStatusType.Active():
      result = "قابل استفاده";
      break;
    case LineStateStatusType.Expired():
      result = "منقضی";
      break;
    case LineStateStatusType.Extended():
      result = "تمدید";
      break;
    case LineStateStatusType.Canceled():
      result = "لغو شده";
      break;
    case LineStateStatusType.SeparateFromPackage():
      result = "جدا شده از بسته";
      break;
    case LineStateStatusType.Archived():
      result = "آرشیو شده";
      break;
      case LineStateStatusType.RejectActivation():
        result = "عدم فعال‌سازی";
        break;
        case LineStateStatusType.Cancelled():
          result = "لغو شده" 
          break;
    default:
      result = "";
      break;
  }
  return result;
}
export default GetLineStateText;
